import React from "react";
import * as Yup from "yup";
import { Grid } from "@material-ui/core";
import { Form as FormikForm, TextField, DatePickerField, Masks } from "components/common_components/Formik";
import { hasAttributes } from "utils/objects";

const Immigration = ({ advancedFilters, onSubmitHandler }) => {
    const validationSchema = Yup.object({
        fileNo: Yup.string().notRequired().nullable(),
        alienRegistrationNo: Yup.string()
            .test("Valid alien registration number", "Incorrect format. Example 123-456-789", (value) =>
                value ? /^\d\d\d-\d\d\d-\d\d\d/.test(value) : true
            )
            .notRequired()
            .nullable(),
        srcNo: Yup.string().notRequired().nullable().max(50),
        petitioner: Yup.string().notRequired().nullable(),
        client_firstName: Yup.string().notRequired().nullable(),
        client_lastName: Yup.string().notRequired().nullable(),
        client_middleName: Yup.string().notRequired().nullable(),
        client_address: Yup.string().notRequired().nullable(),
        client_city: Yup.string().notRequired().nullable(),
        client_homePhone: Yup.string()
            .test("Valid home phone", "Incorrect format. Example 123-456-7890", (value) =>
                value ? /^\d\d\d-\d\d\d-\d\d\d\d/.test(value) : true
            )
            .notRequired()
            .nullable(),
        client_birthDate: Yup.date().notRequired().nullable(),
        client_email: Yup.string().email("Incorrect email").notRequired().nullable(),
        client_ssn: Yup.string()
            .test("Valid SSN", "Incorrect format. Example 123-45-6789", (value) => (value ? /^\d\d\d-\d\d-\d\d\d\d/.test(value) : true))
            .notRequired()
            .nullable(),
    });

    function submitHandler(values, form) {
        const { client_birthDate: bDate, ...payload } = values;

        if (bDate && bDate instanceof Date) {
            payload.client_birthDate = bDate.getTime();
        }

        onSubmitHandler(payload, form);
    }

    const initialValues = (() => {
        if (hasAttributes(advancedFilters)) {
            const bthD = advancedFilters.client_birthDate;
            const parsedBirthDate = bthD && typeof bthD === "number" ? new Date(bthD) : null;
            return { ...advancedFilters, client_birthDate: parsedBirthDate };
        }

        return {
            client_birthDate: null,
        };
    })();

    return (
        <FormikForm
            id="adv-filters-dialog-form"
            onSubmit={submitHandler}
            validateOnChange={false}
            initialValues={initialValues}
            validationSchema={validationSchema}
            showButtons={false}
        >
            <Grid container spacing={2}>
                <Grid item xs={4}>
                    <TextField fieldName="fileNo" label="File No" />
                </Grid>
                <Grid item xs={4}>
                    <TextField fieldName="alienRegistrationNo" label="Alien Registration No." mask={Masks.alienRegistrationNo} />
                </Grid>
                <Grid item xs={4}>
                    <TextField fieldName="petitioner" label="Petitioner" />
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid item xs={4}>
                    <TextField fieldName="client_lastName" label="Last Name" />
                </Grid>
                <Grid item xs={4}>
                    <TextField fieldName="client_firstName" label="First Name" />
                </Grid>
                <Grid item xs={4}>
                    <TextField fieldName="client_middleName" label="Middle Name" />
                </Grid>

                <Grid item xs={4}>
                    <DatePickerField fieldName="client_birthDate" label="Birth date" />
                </Grid>
                <Grid item xs={4}>
                    <TextField fieldName="client_address" label="Address" />
                </Grid>
                <Grid item xs={4}>
                    <TextField fieldName="client_city" label="City" />
                </Grid>

                <Grid item xs={4}>
                    <TextField fieldName="client_homePhone" label="Home Phone" mask={Masks.phoneNumber} />
                </Grid>
                <Grid item xs={4}>
                    <TextField fieldName="client_email" label="Email" helperText="e.g. myclient@domain.com" lowercase />
                </Grid>
                <Grid item xs={4}>
                    <TextField fieldName="client_ssn" label="SSN" lowercase mask={Masks.ssn} />
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid item xs={4}>
                    <TextField fieldName="srcNo" label="SRC No." />
                </Grid>
            </Grid>
        </FormikForm>
    );
};

export default Immigration;
